import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { THEME } from 'src/enums/theme';
import amzLogoBlack from 'src/images/Amazon_Logo_Black.png';
import amzLogoWhite from 'src/images/Amazon_Logo_White.png';

import styles from './Logo.module.scss';

interface LogoProps {
  altText: string;
  href: string;
  theme?: THEME;
}

export const Logo: FunctionComponent<LogoProps> = ({ altText, href, theme = THEME.LIGHT }) => {
  const srcImage = theme === THEME.DARK ? amzLogoWhite : amzLogoBlack;

  return (
    <a className={styles.link} href={href}>
      <img alt={altText} className={classNames(styles.logo, styles.amzLogo)} src={srcImage} />
    </a>
  );
};
